import React from 'react';
import styled, { keyframes } from 'styled-components';

interface LoadingProps {
  size?: string;
  /** Ẩn nền + chữ, chỉ hiện vòng xoay (dùng khi nhúng trong nút/ô nhỏ) */
  bare?: boolean;
  text?: string;
}

// Spinner tối giản, chuyên nghiệp — bám màu chủ đạo (--primary-color) nên tự đổi theo theme.
export const Loading: React.FC<LoadingProps> = ({ size = '2.75rem', bare = false, text = 'Đang tải...' }) => {
  return (
    <SpinnerContainer $bare={bare}>
      <Ring $size={size} />
      {!bare && <LoadingText>{text}</LoadingText>}
    </SpinnerContainer>
  );
};

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const SpinnerContainer = styled.div<{ $bare: boolean }>`
  height: 100%;
  width: 100%;
  min-height: ${(props) => (props.$bare ? 'auto' : '180px')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  background: ${(props) => (props.$bare ? 'transparent' : 'var(--layout-body-bg-color, #f8fafa)')};
`;

const Ring = styled.div<{ $size: string }>`
  width: ${(props) => props.$size};
  height: ${(props) => props.$size};
  border-radius: 50%;
  border: 3px solid rgba(var(--primary-rgb-color, 0, 76, 76), 0.15);
  border-top-color: var(--primary-color, #004c4c);
  border-right-color: var(--primary-color, #004c4c);
  animation: ${spin} 0.7s linear infinite;
`;

const LoadingText = styled.div`
  color: var(--text-secondary-color, #6b7280);
  font-size: 0.875rem;
  font-weight: 500;
  letter-spacing: 0.02em;
`;
